<template>
    <v-icon size="small" end @click="showPriceDetails">mdi-information-outline</v-icon>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_FLIGHT_PRICE_DETAIL} from '@/utils/event-bus'

    @Component
    export class PriceDetailsBtn extends Vue {
        @Prop({required: true}) offer

        showPriceDetails() {
            EventBus.$emit(SHOW_FLIGHT_PRICE_DETAIL, this.offer)
        }
    }

    export default PriceDetailsBtn
</script>
